import type { ForwardedRef, ReactNode } from 'react';

import { forwardRef, memo } from 'react';
import { RouterProvider } from 'react-router';
import LoaderOverlay from '@ricoh/ria.client.core/components/indicator/loader/overlay';

import type { AppRouterProviderProps, AppRouterProviderRef } from './_.type';

import createRouterConfig from '../_config';
import useAppRouterProviderHooks from './_.hook';

const routerConfig = createRouterConfig({
  hydrateFallback: <LoaderOverlay type="converging-spinner" />,
});

/** AppRouterProvider. */
export default memo(
  forwardRef(function AppRouterProvider(props: AppRouterProviderProps, ref: ForwardedRef<AppRouterProviderRef>): ReactNode {
    useAppRouterProviderHooks(props, ref);

    return <RouterProvider {...routerConfig} />;
  }),
);
